import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '@shared/context/AuthContext';
import { User } from '@shared/auth/type';

import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
import Notify from '@shared/notify';
const EventSource = NativeEventSource || EventSourcePolyfill;
// OR: may also need to set as global property
global.EventSource = NativeEventSource || EventSourcePolyfill;
const Progress = (props: any) => {
    const { setProgress, progressType, setDemandStatus } = useContext(AuthContext);
    const [progress, setProgres] = useState(0);

    useEffect(() => {
        // Initialize the incremental value

        const userStr = localStorage.getItem('user');
        const user: User = JSON.parse(userStr!);

        const eventSourceInitDict = { headers: { Authorization: `${user?.token}` } };

        const eventSource = new EventSourcePolyfill(
            `${process.env.REACT_APP_API_BASE_URL}bulk/sse`,
            eventSourceInitDict,
        );

        eventSource.onmessage = event => {
            const data = JSON.parse(event.data);

            let parsedData: any = null;
            if (data?.message) {
                parsedData = JSON.parse(data?.message);
                if (progressType) {
                    if (parsedData.eventId == localStorage.getItem('randomId')) {
                        setProgres(parsedData.progress);

                        if (parsedData.progress == 100) {
                            setTimeout(() => {
                                setProgress(false);

                                Notify('success', 'Bulk Uploaded successfully');
                            }, 2000);
                            setDemandStatus('transporter');
                        }
                    }
                } else {
                    if (parsedData.eventId == localStorage.getItem('otherrandomId')) {
                        setProgres(parsedData.progress);
                        if (parsedData.progress == 100) {
                            setTimeout(() => {
                                setProgress(false);

                                Notify('success', 'Bulk Uploaded successfully');
                            }, 2000);
                            setDemandStatus('others');
                        }
                    }
                }
            }
        };

        eventSource.onerror = error => {
            // console.error('Error with the EventSource:', error);
        };
        return () => {
            eventSource.close();
        };
    }, []);

    return (
        <div className="progress">
            <div
                className="progress-done"
                style={{
                    opacity: 1,
                    width: `${parseInt(progress.toString())}%`,
                }}
            >
                {parseInt(progress.toString())}%
            </div>
        </div>
    );
};

export default Progress;
